export default "https://assets-v2.scaler.com/packs/files/chatbot-character.daea6d.webp";